module.exports = __webpack_public_path__ + "static/media/infoImage-02.9d74416a.png";